import Modal from "bootstrap5/js/dist/modal";

const modal = document.getElementById('confirm-modal')
const modalTitle = modal.querySelector('h4');
const modalContent = modal.querySelector('p');
const modalBtn = modal.querySelector('.btn-primary');
const modalBtnContent = modalBtn.querySelector('span');

const confirm = el => e => {
  e.preventDefault();
  const data = el.dataset;
  modalTitle.innerText = data.confirmTitle || modalTitle.dataset.default;
  modalContent.innerText = data.confirmContent || modalContent.dataset.default;
  modalBtnContent.innerText = data.confirmButton || modalBtnContent.dataset.default;
  modalBtn.onclick = () => window.location.href = el.getAttribute('href') || data.url;
  Modal.getOrCreateInstance(modal).show();
  return false;
}

const initConfirm = () => Array.from(document.querySelectorAll('[data-toggle=confirm]')).forEach(el => {
  el.onclick = confirm(el);
})

export default initConfirm;
